import { render } from "./Hot.vue?vue&type=template&id=0191b2e7"
import script from "./Hot.vue?vue&type=script&lang=js"
export * from "./Hot.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__